<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
          <div class="card-toolbar">
            <ButtonDropdownFilter
                  :btn-title="$t('estimate.all_prospects')"
                  :options="contacts"
                  value-field="id"
                  name-field="fullname"
                  v-model="query.contact_id"
                  :border="true"
              />
          </div>   
        </div>
        <Loader :is-loading="loading">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-3" v-for="(status, index) in statEstimateStatus" :key="index">
                <div class="card p-5 bg-light-primary">
                  <div class="d-flex flex-stack">
                    <div class="symbol symbol-40px me-4">
                      <div class="symbol-label fs-2" :class="'bg-'+filterStatus(status.name)[0]?.color">
                        <i class="fas fa-file-alt fs-2" style="color: white;"></i>
                      </div>
                    </div>
                    <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                      <div class="flex-grow-1 me-2">
                        <a class="text-black fs-6 fw-bolder">
                          {{$t('devis.devis') + ' ' + filterStatus(status.name)[0]?.[locale]}}
                        </a>
                        <span class="text-muted fw-bold d-block fs-7">{{status?.count}}</span>
                      </div>
                      <span class="fw-bold d-block fs-7 mt-2" :class="'text-'+filterStatus(status.name)[0]?.color">{{formattedLocalAmount(status?.amount)}} {{defaultCurrency?.symbol}}</span>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import { onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';
import {formattedLocalAmount} from "@/mixins/Helpers";
import { computed } from 'vue';
import { useLocales } from '@/composables/locales';
import Loader from '@/components/Loader.vue';

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})
  
const query = ref({
    start_date: '',
    end_date: '',
    seller_id: '',
    contact_id: ''
})

const statEstimateStatus = ref([])


const contacts = computed(() => store.getters['contacts/getContacts'])
const estimateStatus = computed(() => store.getters['estimates/estimateStatus'])
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, contact_id: query.value.contact_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          statEstimateStatus.value = res?.data?.estimateStatusTurnover || res?.response?.estimateStatusTurnover;


        }),
        store.dispatch('estimates/loadEstimateStatus'),
        store.dispatch('contacts/loadContacts'), 
        store.dispatch('company/generalInformation'),
      
    ]).then(() => {
    })
  }
    
}

function filterStatus(value){
    let statistic = estimateStatus.value.filter(status => status.value === value)
    return statistic
  }
  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
  
    
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>